<router-outlet></router-outlet>

<!-- <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-loader" [fullScreen]="true"></ngx-spinner> -->

<ngx-spinner bdColor="rgba(0,0,0,0.2)" size="medium" [fullScreen]="true" template='<img src="assets/img/tealoader.gif">'></ngx-spinner>

